import React, { Component } from 'react'
import { Text, View, StyleSheet } from 'react-native'
import { RadioButtonWithTitle } from '../../ui';
import Theme from '../../theme';

class HomeInviteSelection extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedOption: 'No',
        }
    }

    updatedSelectedOption = () => {
        this.setState({ selectedOption: this.state.selectedOption === 'Yes' ? 'No' : 'Yes' });
    }
    render() {
        const { selectedOption } = this.state;
        return (
            <View style={styles.mainContainer}>
                <Text style={styles.heading}>INVITE FRIENDS</Text>
                <View style={styles.optionsContainer}>
                    <View style={styles.radioButtonContainer}>
                        <RadioButtonWithTitle
                            isActive={selectedOption === 'Yes'}
                            title="Yes"
                            onPress={this.updatedSelectedOption}
                        />
                    </View>
                    <View style={styles.verticalSeparator} />
                    <View style={styles.radioButtonContainer}>
                        <RadioButtonWithTitle
                            isActive={selectedOption === 'No'}
                            title="No"
                            onPress={this.updatedSelectedOption}
                        />
                    </View>
                </View>
            </View>
        )
    }
}



const styles = StyleSheet.create({
    mainContainer: {
        backgroundColor: 'white',
        padding: 5,
        paddingVertical: 10,
    },
    heading: {
        paddingHorizontal: 10,
        color: Theme.CHARCOAL,
        fontSize: 18,
        fontFamily: Theme.Custom600,
    },
    optionsContainer: {
        padding: 5,
        flexDirection: 'row',
    },
    radioButtonContainer: {
        padding: 5,
        width: '40%',
    },
    verticalSeparator: {
        width: 2,
        marginHorizontal: 10,
        backgroundColor: Theme.GREY_LIGHT,
    },
});

export default HomeInviteSelection;